import * as projects from '../services/app';
import * as auth from '../services/authentication';
import { ActionTypes } from '../types/action-types';
import { ActionObject, ISession } from '../types/authentication';

export const loggingIn = (): ActionObject => ({
    type: ActionTypes.USER_LOGIN_REQUEST,
});

export const logginVerifying = (): ActionObject => ({
    type: ActionTypes.USER_LOGIN_VERIFYING,
});

export const loginRequest = (): ActionObject => ({
    type: ActionTypes.USER_LOGIN_REQUEST,
});

export const loginFailed = () => ({
    type: ActionTypes.USER_LOGIN_FAILURE,
});

export const loginSuccess = (session: ISession) => ({
    type: ActionTypes.USER_LOGIN_SUCCESS,
    session
});

export const login = (email: string, password: string) => async dispatch => {
    const session = await auth.login(email, password);
    if (session && session.id) {
        const result = await projects.getProjects(session.id);
        dispatch({
            type: ActionTypes.PROFILE_PROJECTS_LOADED,
            projects: result
        });
        dispatch(loginSuccess(session));
    } else {
        dispatch({
            type: ActionTypes.PROFILE_PROJECTS_LOADED,
            projects: [],
        });
        dispatch(loginFailed());
    }
}

export const loginWithToken = (accessToken: string) => async dispatch => {
    const session = await auth.loginWithToken(accessToken);
    if (session && session.id) {
        const result = await projects.getProjects(session.id);
        dispatch({
            type: ActionTypes.PROFILE_PROJECTS_LOADED,
            projects: result
        });
        dispatch(loginSuccess(session));
    } else {
        dispatch({
            type: ActionTypes.PROFILE_PROJECTS_LOADED,
            projects: [],
        });
        dispatch(loginFailed());
    }
}

export const logout = () => async dispatch => {
    await auth.logout()
    dispatch({
        type: ActionTypes.PROFILE_PROJECTS_LOADED,
        projects: [],
    });
    dispatch({
        type: ActionTypes.USER_LOGOUT_SUCCESS
    });
}




// WEBPACK FOOTER //
// ./src/actions/authentication.ts